import { render, staticRenderFns } from "./defaultPayBreakdownSnapshot.vue?vue&type=template&id=b113b492"
import script from "./defaultPayBreakdownSnapshot.vue?vue&type=script&lang=js"
export * from "./defaultPayBreakdownSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports